import jwtAuthAxios from "./auth/jwtAuth";

// Xpit Assistant: la conversación del usuario en su empresa activa. Enviar un mensaje devuelve 202 y la respuesta se
// consulta con getConversation(afterId) mientras pending sea true.
const aiAssistantServices = {};

aiAssistantServices.getConversation = async (afterId = null) => {
    const { data } = await jwtAuthAxios.get("/ai_assistant/conversation", { params: afterId ? { after_id: afterId } : {} });
    return data;
};

aiAssistantServices.sendMessage = async (content, context = {}) => {
    const { data } = await jwtAuthAxios.post("/ai_assistant/conversation/messages", { message: { content, context } });
    return data;
};

aiAssistantServices.updateDraftStatus = async (messageId, draftStatus) => {
    const { data } = await jwtAuthAxios.patch(`/ai_assistant/messages/${messageId}/draft_status`, {
        draft_status: draftStatus,
    });
    return data;
};

export default aiAssistantServices;
